import { Box, FormControl, TextField } from "@mui/material";
import { DateType } from "../../utils/dateHandler"
import { DesktopDatePicker, LocalizationProvider, jaJP } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { datePickerConst } from "../../const/commonConst";
import { searchDateBox } from "../../../carUseResult/const/carUseResultPageSize";

type PropsType = {
    searchDate: DateType | null;
    handleChangeSearchDate: (newValue: DateType | null) => void;
}

/**
 * 検索日選択ボックス
 */
export const SearchDate = (props: PropsType) => {
    const { searchDate, handleChangeSearchDate } = props;

    return (
        <FormControl>
            <Box sx={{ width: searchDateBox.width, position: 'relative', left: '10px'}}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={jaJP} dateFormats={{ monthAndYear: datePickerConst.monthAndYear }}>
                    <DesktopDatePicker
                        className="searchDate"
                        value={searchDate}
                        onChange={handleChangeSearchDate}
                        inputFormat={datePickerConst.inputFormat}
                        mask={datePickerConst.mask}
                        renderInput={(params) => <TextField {...params} size="small" sx={{ flexGrow: 1, display: 'flex' }} />}
                    />
                </LocalizationProvider>
            </Box>
        </FormControl>
    );
}